(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    (function () {
    // Shopify accepts a send date up to 90 days out
    var MAX_SEND_DAYS = 90;

    function localIsoDate(daysAhead) {
      var date = new Date();
      date.setDate(date.getDate() + daysAhead);
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return date.getFullYear() + '-' + month + '-' + day;
    }

    function clearError(root, key) {
      var slot = root.querySelector('[data-recipient-error="' + key + '"]');
      var field = root.querySelector('[data-recipient-field="' + key + '"]');
      if (slot) {
        slot.hidden = true;
        slot.textContent = '';
      }
      if (field) field.removeAttribute('aria-invalid');
    }

    function setup(root) {
      var toggle = root.querySelector('[data-recipient-toggle]');
      var fields = root.querySelector('[data-recipient-fields]');
      var offset = root.querySelector('[data-recipient-offset]');
      var sendOn = root.querySelector('[data-recipient-field="send_on"]');
      if (!toggle || !fields) return;

      // Lets Shopify schedule "Send on" in the buyer's timezone
      if (offset) offset.value = new Date().getTimezoneOffset().toString();
      if (sendOn) {
        sendOn.min = localIsoDate(0);
        sendOn.max = localIsoDate(MAX_SEND_DAYS);
      }

      function sync() {
        var sendToRecipient = toggle.checked;
        fields.hidden = !sendToRecipient;
        fields.querySelectorAll('input, textarea').forEach(function (input) {
          input.disabled = !sendToRecipient;
        });
        if (!sendToRecipient) {
          root.querySelectorAll('[data-recipient-field]').forEach(function (field) {
            clearError(root, field.getAttribute('data-recipient-field'));
          });
        }
      }

      root.querySelectorAll('[data-recipient-field]').forEach(function (field) {
        field.addEventListener('input', function () {
          clearError(root, field.getAttribute('data-recipient-field'));
        });
      });

      toggle.disabled = false;
      toggle.addEventListener('change', sync);
      sync();
    }

    function init() {
      document.querySelectorAll('[data-gift-card-recipient]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-nav"] && !Shopify.designMode) return;
  try {
    class MobileNav extends HTMLElement {
    constructor() {
      super();
      this.nav = this.querySelector('[data-mobile-nav]');
      this.panel = this.querySelector('[data-nav-panel]');
      this.overlay = this.querySelector('[data-nav-overlay]');
      this.closeButton = this.querySelector('[data-nav-close]');
      
      this.onOverlayClick = this.onOverlayClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onEscapeKey = this.onEscapeKey.bind(this);
    }

    connectedCallback() {
      this.overlay?.addEventListener('click', this.onOverlayClick);
      this.closeButton?.addEventListener('click', this.onCloseClick);
      
      // Listen for menu toggle from header
      document.addEventListener('mobile-nav:toggle', () => this.toggle());
    }

    disconnectedCallback() {
      this.overlay?.removeEventListener('click', this.onOverlayClick);
      this.closeButton?.removeEventListener('click', this.onCloseClick);
      document.removeEventListener('keydown', this.onEscapeKey);
    }

    open() {
      this.nav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onEscapeKey);
    }

    close() {
      this.nav.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onEscapeKey);
    }

    toggle() {
      if (this.nav.classList.contains('is-open')) {
        this.close();
      } else {
        this.open();
      }
    }

    onOverlayClick() {
      this.close();
    }

    onCloseClick() {
      this.close();
    }

    onEscapeKey(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }
  }

  if (!customElements.get('mobile-nav')) {
    customElements.define('mobile-nav', MobileNav);
  }

  // Connect header menu toggle to mobile nav
  document.addEventListener('DOMContentLoaded', () => {
    const menuToggle = document.querySelector('[data-menu-toggle]');
    if (menuToggle) {
      menuToggle.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('mobile-nav:toggle'));
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdf-download-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function PdfModal(root) {
      this.root = root;
      this.dialog = root.querySelector('.pdf-modal__dialog');
      this.steps = {};
      root.querySelectorAll('[data-pdf-modal-step]').forEach(function (step) {
        this.steps[step.getAttribute('data-pdf-modal-step')] = step;
      }, this);
      this.lastFocused = null;
      this.bind();
    }

    PdfModal.prototype.bind = function () {
      var self = this;

      this.root.querySelectorAll('[data-pdf-modal-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.close();
        });
      });

      this.root.querySelectorAll('[data-pdf-modal-form]').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          self.submit(form);
        });
      });

      this.onKeydown = function (event) {
        if (event.key === 'Escape') {
          self.close();
          return;
        }
        if (event.key !== 'Tab') return;

        var focusable = Array.prototype.filter.call(
          self.dialog.querySelectorAll(FOCUSABLE),
          function (el) { return el.offsetParent !== null; }
        );
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };
    };

    PdfModal.prototype.open = function () {
      this.lastFocused = document.activeElement;
      this.root.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);

      var focusTarget = this.root.querySelector('[data-pdf-modal-step]:not([hidden]) [data-pdf-modal-email]');
      if (focusTarget) focusTarget.focus();
    };

    PdfModal.prototype.close = function () {
      this.root.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
      if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
      this.reset();
    };

    // Back to step one so a second open does not land on the confirmation.
    PdfModal.prototype.reset = function () {
      var self = this;
      Object.keys(this.steps).forEach(function (name) {
        self.steps[name].hidden = name !== 'form';
      });
      this.root.querySelectorAll('[data-pdf-modal-form]').forEach(function (form) {
        form.hidden = false;
        form.reset();
      });
      this.root.querySelectorAll('[data-pdf-modal-error]').forEach(function (el) {
        el.hidden = true;
        el.textContent = '';
      });
      this.root.querySelectorAll('[data-pdf-modal-email]').forEach(function (el) {
        el.removeAttribute('aria-invalid');
      });
      this.root.querySelectorAll('[data-pdf-modal-success]').forEach(function (el) {
        el.hidden = true;
      });
    };

    PdfModal.prototype.showError = function (form, message) {
      var error = form.querySelector('[data-pdf-modal-error]');
      var input = form.querySelector('[data-pdf-modal-email]');
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
    };

    PdfModal.prototype.clearError = function (form) {
      var error = form.querySelector('[data-pdf-modal-error]');
      var input = form.querySelector('[data-pdf-modal-email]');
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
      if (input) input.removeAttribute('aria-invalid');
    };

    PdfModal.prototype.send = function (email) {
      var endpoint = this.root.getAttribute('data-endpoint');
      if (!endpoint || !email) return Promise.resolve();

      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          source: this.root.id,
          page: window.location.href
        })
      }).catch(function () {
        // A failed signup must never block the download.
      });
    };

    PdfModal.prototype.download = function () {
      var url = this.root.getAttribute('data-pdf-url');
      if (!url) return;

      var filename = 'download.pdf';
      try {
        var path = new URL(url, window.location.href).pathname;
        var last = path.substring(path.lastIndexOf('/') + 1);
        if (last) filename = decodeURIComponent(last);
      } catch (e) {
        // Keep the fallback filename.
      }

      function save(href, isBlob) {
        var link = document.createElement('a');
        link.href = href;
        link.download = filename;
        link.rel = 'noopener';
        // A blob URL is same-origin, so it saves without opening a tab.
        if (!isBlob) link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        if (isBlob) {
          setTimeout(function () { URL.revokeObjectURL(href); }, 10000);
        }
      }

      // The PDF is cross-origin, so the download attribute is ignored on a
      // direct link and the file just opens in a tab. Shopify's CDN sends
      // Access-Control-Allow-Origin, so fetching it as a blob gives us a
      // same-origin URL the attribute does respect, which actually saves it.
      if (typeof fetch !== 'function' || !window.URL || !URL.createObjectURL) {
        save(url, false);
        return;
      }

      fetch(url, { mode: 'cors', credentials: 'omit' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unexpected status ' + response.status);
          return response.blob();
        })
        .then(function (blob) {
          save(URL.createObjectURL(blob), true);
        })
        .catch(function () {
          save(url, false);
        });
    };

    PdfModal.prototype.submit = function (form) {
      var self = this;
      var mode = form.getAttribute('data-pdf-modal-form');
      var input = form.querySelector('[data-pdf-modal-email]');
      var button = form.querySelector('[data-pdf-modal-submit]');
      var email = input ? input.value.trim() : '';

      // Step one downloads with or without an email; step two exists only to sign up.
      if (!email && mode === 'signup') {
        this.showError(form, 'Enter your email address.');
        return;
      }
      if (email && !EMAIL_RE.test(email)) {
        this.showError(form, 'Enter a valid email address.');
        return;
      }
      this.clearError(form);

      if (button) button.disabled = true;

      // Kick the download off while the click is still the active user gesture.
      if (mode === 'download') this.download();

      this.send(email).then(function () {
        if (button) button.disabled = false;

        if (mode === 'download') {
          self.steps.form.hidden = true;
          self.steps.confirm.hidden = false;
          var next = self.steps.confirm.querySelector('[data-pdf-modal-email]');
          if (email && next) {
            // Already signed up on step one, so do not ask again.
            var confirmForm = self.steps.confirm.querySelector('[data-pdf-modal-form]');
            var success = self.steps.confirm.querySelector('[data-pdf-modal-success]');
            if (confirmForm) confirmForm.hidden = true;
            if (success) success.hidden = false;
          } else if (next) {
            next.focus();
          }
        } else {
          form.hidden = true;
          var done = self.steps.confirm.querySelector('[data-pdf-modal-success]');
          if (done) done.hidden = false;
        }
      });
    };

    function initPdfModals(scope) {
      (scope || document).querySelectorAll('[data-pdf-modal]').forEach(function (root) {
        if (root.dataset.pdfModalBound === 'true') return;
        root.dataset.pdfModalBound = 'true';
        root.pdfModal = new PdfModal(root);
      });

      (scope || document).querySelectorAll('[data-pdf-modal-open]').forEach(function (trigger) {
        if (trigger.dataset.pdfModalTriggerBound === 'true') return;
        trigger.dataset.pdfModalTriggerBound = 'true';

        trigger.addEventListener('click', function (event) {
          var target = document.getElementById(trigger.getAttribute('data-pdf-modal-open'));
          if (!target || !target.pdfModal) return;
          event.preventDefault();
          target.pdfModal.open();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initPdfModals(); });
    } else {
      initPdfModals();
    }

    // Theme editor re-renders sections in place.
    document.addEventListener('shopify:section:load', function (event) { initPdfModals(event.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-popup"] && !Shopify.designMode) return;
  try {
    function initVideoPopups(scope) {
    (scope || document).querySelectorAll('[data-video-popup-open]').forEach((trigger) => {
      if (trigger.dataset.videoPopupBound === 'true') return;
      trigger.dataset.videoPopupBound = 'true';

      trigger.addEventListener('click', () => {
        const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;

        const player = dialog.querySelector('.video-popup__player');
        const template = dialog.querySelector('template');
        if (!player || !template) return;

        dialog.videoPopupTrigger = trigger;
        player.replaceChildren(template.content.cloneNode(true));
        dialog.showModal();

        const closeButton = dialog.querySelector('[data-video-popup-close]');
        if (closeButton) closeButton.focus();

        const video = player.querySelector('video');
        if (video) video.play().catch(() => {});
      });
    });

    (scope || document).querySelectorAll('.video-popup').forEach((dialog) => {
      if (dialog.dataset.videoPopupBound === 'true') return;
      dialog.dataset.videoPopupBound = 'true';

      const closeButton = dialog.querySelector('[data-video-popup-close]');
      if (closeButton) closeButton.addEventListener('click', () => dialog.close());

      // A click on the backdrop targets the dialog itself; the player fills its box.
      // A drag between the player and the backdrop (scrubbing, volume) also
      // clicks the dialog, so only close when the press and release were both
      // on the backdrop. Closing on the click, not pointerup, keeps a tap from
      // landing on the page underneath.
      let backdropPress = false;
      dialog.addEventListener('pointerdown', (event) => {
        backdropPress = event.target === dialog;
      });
      dialog.addEventListener('pointerup', (event) => {
        if (event.target !== dialog) backdropPress = false;
      });
      dialog.addEventListener('click', (event) => {
        // detail > 1: the second click of a double-click on a trigger lands on
        // the backdrop the first click just opened. The box check skips the
        // player's rounded corners, which also target the dialog.
        const box = dialog.getBoundingClientRect();
        const outside =
          event.clientX < box.left ||
          event.clientX > box.right ||
          event.clientY < box.top ||
          event.clientY > box.bottom;
        if (event.target === dialog && backdropPress && outside && event.detail < 2) dialog.close();
        backdropPress = false;
      });

      // Fires for every way out, Esc included.
      dialog.addEventListener('close', () => {
        const player = dialog.querySelector('.video-popup__player');
        if (player) player.replaceChildren();

        const trigger = dialog.videoPopupTrigger;
        if (trigger && trigger.isConnected) trigger.focus();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initVideoPopups());
  } else {
    initVideoPopups();
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => initVideoPopups(event.target));
  } catch(e) { console.error(e); }
})();

})();
